import {get, post, postJson} from './axios'

// const RESOURCE_BASE_PATH = '/jd-yusms'
const RESOURCE_BASE_PATH = '/buyerLabel'

// 会员列表分页查询
export const getBuyerLabel = p => get(`${RESOURCE_BASE_PATH}/list`, p);
